<ng-container *ngIf="isBrowser">
  <div *ngIf="showGreetingChoice" class="greeting-choice-modal">
    <button
      type="button"
      class="greeting-choice-close"
      aria-label="Close"
      (click)="close()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="greeting-choice-header">
      <span class="greeting-kicker">GREETING VIDEO</span>
      <h5 class="greeting-choice-title">Add a Greeting</h5>
      <p class="greeting-choice-description" *ngIf="!shrinkingGreeting">
        A short, friendly video helps people understand what you're asking —
        and makes them far more likely to respond.
      </p>
      <p class="greeting-choice-description" *ngIf="shrinkingGreeting">
        Preparing a smaller copy so it sends faster. Keep this screen on.
      </p>
    </div>
    <div class="greeting-choice-cards">
      <button
        type="button"
        class="greeting-choice-card"
        (click)="selectRecordVideo()"
        [disabled]="shrinkingGreeting"
      >
        <span class="greeting-card-icon">
          <i class="fa-solid fa-video" aria-hidden="true"></i>
        </span>
        <span class="greeting-card-title">Record Video</span>
        <span class="greeting-card-subtitle">Use your camera now</span>
      </button>
      <button
        type="button"
        class="greeting-choice-card"
        (click)="triggerGreetingUpload()"
        [disabled]="shrinkingGreeting"
      >
        <span class="greeting-card-icon">
          <i class="fa-solid fa-arrow-up-from-bracket" aria-hidden="true"></i>
        </span>
        <span class="greeting-card-title">Upload Video</span>
        <span class="greeting-card-subtitle">Choose an existing file</span>
      </button>
    </div>
    <button type="button" class="greeting-cancel-btn" (click)="close()">
      Cancel
    </button>
    <input
      #greetingUploadInput
      type="file"
      hidden
      accept="video/*"
      (change)="onGreetingFileSelected($event)"
      aria-label="Upload greeting video file"
    />
  </div>

  <ng-container *ngIf="!showGreetingChoice">
    <div class="recorder-shell">
      <button
        type="button"
        class="recorder-close-btn"
        aria-label="Close"
        (click)="showCloseConfirm = true"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>

      <div class="recorder-header">
        <div *ngIf="initialState.isCamera" class="align_text">
          Take a Selfie with a smile
        </div>
        <div
          *ngIf="!initialState.isCamera && questionModels.length"
          class="button-container"
        >
          <button
            type="button"
            *ngIf="primary_color"
            [ngClass]="{ disable_question_picker: hideNavigation }"
            [style.border-color]="primary_color ? primary_color : ''"
            [style.color]="primary_color ? primary_color : ''"
            (click)="prev()"
            class="button_recorder_styles_prev"
          >
            <span aria-hidden="true"> Prev</span>
          </button>
        </div>

        <div *ngIf="!initialState.isCamera" class="title_container">
          <h5 class="modal-title">
            Record a Greeting, Instructions or Story Tip
          </h5>
        </div>
        <div
          *ngIf="!initialState.isCamera && questionModels.length"
          class="button-container"
        >
          <button
            *ngIf="primary_color"
            [ngClass]="{ disable_question_picker: hideNavigation }"
            type="button"
            (click)="next()"
            [style.border-color]="primary_color ? primary_color : ''"
            [style.background]="primary_color ? primary_color : ''"
            class="button_recorder_styles"
          >
            <span aria-hidden="true"> Next </span>
          </button>
        </div>
      </div>

      <div
        class="recorder-device-row"
        *ngIf="
          initiaCameraSelect &&
          availableaudio.length &&
          availableCamera.length &&
          !initialState.isCamera
        "
      >
        <div class="device-select">
          <button
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="device-select-btn dropdown-toggle"
          >
            <span class="device-select-icon">
              <i class="fa fa-microphone" aria-hidden="true"></i>
            </span>
            <span class="device-select-label">{{ selectedAudioLabel }}</span>
            <i class="fa-solid fa-chevron-down device-select-chevron"></i>
          </button>
          <div class="dropdown-menu device-select-menu">
            <scrollbar>
              <div class="dropdown-item" *ngFor="let item of availableaudio">
                <div class="custom-control custom-checkbox">
                  <label class="mb-0">
                    <span
                      class="custom-control-label"
                      (click)="getaudioData(item)"
                      >{{ item.label }}</span
                    >
                  </label>
                </div>
              </div>
            </scrollbar>
          </div>
        </div>

        <div class="device-select">
          <button
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            class="device-select-btn dropdown-toggle"
          >
            <span class="device-select-icon">
              <i class="fa-solid fa-video"></i>
            </span>
            <span class="device-select-label">{{ selectedCameraLabel }}</span>
            <i class="fa-solid fa-chevron-down device-select-chevron"></i>
          </button>
          <div class="dropdown-menu device-select-menu">
            <scrollbar>
              <div class="dropdown-item" *ngFor="let item of availableCamera">
                <div class="custom-control custom-checkbox">
                  <label class="mb-0">
                    <span
                      class="custom-control-label"
                      (click)="getVideoData(item)"
                      >{{ item.label }}</span
                    >
                  </label>
                </div>
              </div>
            </scrollbar>
          </div>
        </div>
      </div>

      <div class="modal-body recorder-body">
        <div class="recorder-preview" [class.is-loading]="ishowLoader">
          <div class="loader_body" *ngIf="ishowLoader">
            <div class="recorder-spinner"></div>
            <p>Preparing your camera...</p>
          </div>
          <div class="permission_message_body" *ngIf="!ishowLoader && permissionBlockedMessage">
            <p class="text-danger mb-0">{{ permissionBlockedMessage }}</p>
          </div>
          <video
            #videoElement
            muted="muted="
            width="640"
            height="360"
            autoplay
          ></video>

          <div class="video-pause-overlay" *ngIf="isPause">
            <i class="fa-solid fa-pause"></i>
          </div>

          <div class="close-overlay" *ngIf="showCloseConfirm">
            <div class="close-popup">
              <p>Are you sure?</p>
              <div class="close-actions">
                <button class="btn-cancel" (click)="showCloseConfirm = false">
                  Cancel
                </button>
                <button class="btn-confirm" (click)="close()">Yes</button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="gs-record-view__footer_recorder"
          *ngIf="!initiaCameraSelect && !initialState.isCamera"
        >
          <div class="video-controls-bar">
            <div
              class="video-btn finish"
              [ngClass]="{ 'disabled-btn': removedisabled }"
              (click)="stopRecordingVideoFile()"
              *ngIf="showalways"
            >
              <i class="fa-solid fa-stop"></i>
              <span>Finish</span>
            </div>

            <div
              #StopButton
              class="video-btn secondary"
              (click)="playVideo()"
              *ngIf="!showWhileRecording && hideAlways"
            >
              <i class="fa-solid fa-play"></i>
              <span>Resume</span>
            </div>

            <div
              class="video-btn secondary"
              [ngClass]="{
                'disabled-btn': removedisabled,
                countdown: timers > 0,
              }"
              (click)="pauseRecordingmedia()"
              *ngIf="showWhileRecording"
            >
              <i class="fa-solid fa-pause"></i>
              <span>Pause</span>
            </div>

            <div
              class="video-btn secondary"
              [ngClass]="{
                'disabled-btn': removedisabled,
                countdown: timers > 0,
              }"
              (click)="retakeVideo()"
              *ngIf="showalways"
            >
              <i class="fa-solid fa-rotate-right"></i>
              <span>Restart</span>
            </div>

            <div class="record_time" *ngIf="showalways">
              {{ formatTime(timer) }}
            </div>

            <div
              class="video-btn secondary"
              [ngClass]="{ countdown: timers > 0 }"
              *ngIf="showalways"
              (click)="showCloseConfirm = true"
            >
              <i class="fa-solid fa-xmark"></i>
              <span>Close</span>
            </div>
          </div>
        </div>
      </div>

      <div class="option_camera" *ngIf="initiaCameraSelect">
        <div
          class="control-container"
          *ngIf="
            availableaudio.length &&
            availableCamera.length &&
            !initialState.isCamera
          "
        >
          <div class="square-btn color-picker">
            <div
              (change)="oncolorChange($event)"
              ngx-colors-trigger
              class="color_picker-s"
              [style.background]="colorValue"
            ></div>
          </div>

          <div
            class="square-btn blur-btn"
            (click)="!blur ? startBlurVirtualBackground() : stopeffect()"
          >
            <img
              *ngIf="!blur"
              style="height: 20px"
              src="assets/front-end-minify/img/icons/blur.png"
              alt=""
            />
            <i *ngIf="blur" class="fa-regular fa-ban"></i>
          </div>

          <div
            #StopButton
            class="rect-btn start-btn"
            (click)="startinitalrecording()"
            [ngClass]="{
              'active-record': !isRecording,
              'disabled-btn': isRecording,
            }"
          >
            <span>Start</span>
          </div>

          <div class="rect-btn disabled-btn">
            <i class="fa-solid fa-pause"></i>
            <span>Pause</span>
          </div>

          <div class="rect-btn disabled-btn">
            <span>Restart</span>
          </div>

          <div class="record_time">00:00:00</div>
        </div>

        <div class="" *ngIf="!availableaudio.length || !availableCamera.length">
          <p class="text-danger recorder-device-error">
            Please check wheather both microphone and camera are plugged in
          </p>
        </div>
      </div>

      <div
        class="gs-record-view__countdown"
        *ngIf="!initiaCameraSelect && timers != 0"
      >
        <p
          [ngClass]="{
            timer: true,
            'timer-running': timers > 0,
            'timer-expired': timers === 0,
          }"
        >
          {{ timers }}
        </p>
      </div>
      <canvas #canvas width="640" height="360" hidden></canvas>
      <canvas #canvasdata width="640" height="360" hidden></canvas>
    </div>
  </ng-container>
</ng-container>
